import {Box} from '~/common/fabric/Card/components/Box/Box';
import {Group} from '~/common/fabric/Card/components/Group/Group';
import {Header} from '~/common/fabric/Card/components/Header/Header';
import {Icons} from '~/common/fabric/Card/components/Icons/Icons';
import {EditBox} from '~/common/fabric/CreateDesign/components/EditBox/EditBox';
import {useEnvelope} from '~/common/fabric/CreateDesign/components/Envelope/actions/useEnvelope';
import {useLiners} from '~/common/fabric/CreateDesign/components/Envelope/actions/useLiner';
import './EnvelopeEditor.sass';

export const EnvelopeEditor = () => {
  const {envelopeIcons, onEnvelopeChange, selectedEnvelope} = useEnvelope();
  const {linerIcons, onLinerChange, selectedLiner} = useLiners();

  return (
    <div className="envelope-editor">
      <EditBox className="envelope-editor__content">
        <Group>
          <Header title="Envelope Colors" />
          <Box className="envelope-editor__box">
            <Icons
              icons={envelopeIcons}
              onClick={onEnvelopeChange}
              selectedIcon={selectedEnvelope?.icon}
              height={40}
              width={40}
              className="envelope-editor__box__icons"
            />
          </Box>
        </Group>
        <Group>
          <Header title="Liners" />
          <Box className="envelope-editor__box">
            <Icons
              icons={linerIcons}
              onClick={onLinerChange}
              square
              selectedIcon={selectedLiner?.icon}
              className="envelope-editor__box__icons envelope-editor__box__icons__liners"
              height={40}
              width={48.33}
            />
          </Box>
        </Group>
      </EditBox>
    </div>
  );
};
